import React from "react";
import { Link } from "react-router-dom";
import { resolveImage } from "../lib/api";

export default function ProductCard({ product }) {
    const primary = product.images?.[0]?.url;
    const secondary = product.images?.[1]?.url || primary;
    const displayPrice = product.on_sale && product.sale_price ? product.sale_price : product.price;
    return (
        <Link
            to={`/product/${product.slug}`}
            className="group block product-hover"
            data-testid={`product-card-${product.id}`}
        >
            <div className="relative overflow-hidden bg-[color:var(--ms-cream)] aspect-[3/4] mb-3">
                {primary ? (
                    <>
                        <img src={resolveImage(primary)} alt={product.title} className="image-primary absolute inset-0 w-full h-full object-cover" />
                        {secondary && (
                            <img src={resolveImage(secondary)} alt="" className="image-secondary absolute inset-0 w-full h-full object-cover" />
                        )}
                    </>
                ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-[color:var(--ms-muted)] text-xs">Nessuna immagine</div>
                )}
                {product.on_sale && (
                    <span className="absolute top-3 left-3 bg-[color:var(--ms-terracotta)] text-[color:var(--ms-warm-white)] text-[10px] tracking-[0.2em] px-2 py-1 font-medium">SCONTO</span>
                )}
                {product.is_new && !product.on_sale && (
                    <span className="absolute top-3 left-3 bg-[color:var(--ms-sage)] text-[color:var(--ms-warm-white)] text-[10px] tracking-[0.2em] px-2 py-1 font-medium">NEW</span>
                )}
            </div>
            <div className="flex justify-between items-start gap-2 px-0.5">
                <div className="min-w-0">
                    {product.brand && <div className="text-[10px] tracking-[0.18em] text-[color:var(--ms-sage-dark)] uppercase truncate">{product.brand}</div>}
                    <div className="text-sm text-[color:var(--ms-charcoal)] font-medium group-hover:text-[color:var(--ms-sage-dark)] transition-colors line-clamp-2 leading-snug mt-0.5">{product.title}</div>
                    {product.age_group && <div className="text-xs text-[color:var(--ms-muted)] mt-1">{product.age_group}</div>}
                </div>
                <div className="text-sm text-[color:var(--ms-charcoal)] font-medium whitespace-nowrap text-right">
                    {product.on_sale && product.sale_price ? (
                        <>
                            <div className="text-[color:var(--ms-terracotta)]">€{displayPrice.toFixed(2)}</div>
                            <div className="text-[color:var(--ms-muted)] line-through text-xs">€{product.price.toFixed(2)}</div>
                        </>
                    ) : (
                        <div>€{product.price.toFixed(2)}</div>
                    )}
                </div>
            </div>
        </Link>
    );
}
